/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.contentEditorModule')
  .controller('BlockCaptionController', [
    '$scope',
    'BulbBrowserService',
    'Restangular',
    'CONTENT_EDITOR',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    BlockCaptionController
  ]);

/**
 * Controller for managing captions on blocks.
 */
function BlockCaptionController($scope, BulbBrowserService, Restangular, CONTENT_EDITOR) {

  this.autoSaveOptions = {
    restId: $scope.contentBlockCtrl.page.unit.id,
    customSave: function customSave() {
      const patch = {
        caption: $scope.contentBlockCtrl.contentBlock.caption
      };
      return Restangular.one('units', $scope.contentBlockCtrl.page.unit.id)
        .one(
          CONTENT_EDITOR.BLOCK_PATHS[$scope.contentBlockCtrl.contentBlock.blockType],
          $scope.contentBlockCtrl.contentBlock.id
        )
        .patch(patch).then((modifiedContentBlock) => {
          if (modifiedContentBlock.caption) {
            modifiedContentBlock.caption = decodeHtmlCharCodes(modifiedContentBlock.caption);
          }
          angular.copy(modifiedContentBlock.plain(), $scope.contentBlockCtrl.contentBlock);
        });
    }
  };

  /**
   * Set the correct maxWidth depending on the content-block type.
   *
   * We wrap the figcaption in an invisible div to handle the issue of BULB-655 -> two-line captions overwriting text.
   * This is a temporary solution. There has been another ticket created, BULB-750, that informs developers to
   * fix this temporary solution. We still need to figure out what is causing this issue
   */
  this.setMaxWidth = function setMaxWidth() {
    let maxWidth;
    if ($scope.contentBlockCtrl.contentBlock.blockType === 'IMAGE') {
      // Need this check because during a resize, an image may be re-sized back to it's full image asset resolution
      // when this happens, the scaledImageAsset is removed from the contentBlockCtrl thus we need to now use the
      // width of the fullImageAsset.
      if (!$scope.contentBlockCtrl.contentBlock.scaledImageAsset) {
        maxWidth = $scope.contentBlockCtrl.contentBlock.fullImageAsset.width;
      } else {
        maxWidth = $scope.contentBlockCtrl.contentBlock.scaledImageAsset.width;
      }
    } else if ($scope.contentBlockCtrl.contentBlock.blockType === 'AUDIO' && BulbBrowserService.isMobile()) {
      maxWidth = $scope.contentBlockCtrl.contentBlock.width;
    } else {
      maxWidth = $scope.contentBlockCtrl.contentBlock.width;
    }
    return maxWidth;
  };


  /**
   * Decode Special Characters used in Image Block caption
   * @param str - String to be decoded.
   */
  function decodeHtmlCharCodes(str) {
    return str.replace(/(&#(\d+);)/g, (match, capture, charCode) => String.fromCharCode(charCode));
  }
}
